import React from 'react';
import './index.css';
import { Link } from 'react-router-dom';

const Terms: React.FC = () => {
  return (
    <div className="terms-page">
      <div className="container">
      <header>
  <h1>TT Saver - Terms of Service</h1>
        <p className="subtitle">End User License Agreement</p>
      </header>

  <p className="effective-date">Effective Date: October 7, 2025</p>

      <div className="section">
        <h2>1. AGREEMENT TO TERMS</h2>
        <p>
          By downloading, installing, or using TT Saver (the "App"), you acknowledge that you have read,
          understood, and agree to be bound by these Terms of Service (the "Terms"). If you do not agree to these Terms,
          you may not access or use the App.
        </p>
        <p>
          We reserve the right to modify these Terms at any time. Any changes will be effective immediately upon posting the
          revised version on this page with an updated "Effective Date". Your continued use of the App following the posting
          of changes constitutes your acceptance of such changes.
        </p>
      </div>

      <div className="section">
        <h2>2. LICENSE GRANT</h2>
        <p>
          Subject to your compliance with these Terms, we grant you a limited, non-exclusive, non-transferable,
          non-sublicensable, revocable license to download, install, and use the App for your personal, non-commercial use
          on devices you own or control.
        </p>
      </div>

      <div className="section">
        <h2>3. SUBSCRIPTIONS AND AUTO-RENEWAL</h2>
  <p>The App may offer auto-renewing subscriptions through in-app purchases. The following terms apply to such subscriptions:</p>

        <div className="legal-notice">
          <h3>NOTICE REGARDING AUTO-RENEWING SUBSCRIPTIONS</h3>
          <ul>
            <li>Payment will be charged to your iTunes Account at confirmation of purchase.</li>
            <li>Subscription automatically renews unless auto-renew is turned off at least twenty-four (24) hours before the end of the current period.</li>
            <li>Your account will be charged for renewal within twenty-four (24) hours prior to the end of the current period.</li>
            <li>You may manage your subscription and turn off auto-renewal by going to your Account Settings after purchase.</li>
            <li>Any unused portion of a free trial period, if offered, will be forfeited when you purchase a subscription.</li>
          </ul>
        </div>
      </div>

      <div className="section">
        <h2>4. USER RESPONSIBILITIES AND RESTRICTIONS</h2>
        <p>You agree not to engage in any of the following prohibited activities:</p>
        <ul>
          <li>Violate any applicable laws, regulations, or third-party rights;</li>
          <li>Use the App for any unlawful, fraudulent, or unauthorized purpose;</li>
          <li>Distribute malware, viruses, or any other destructive code;</li>
          <li>Attempt to reverse-engineer, decompile, disassemble, or modify the App;</li>
          <li>Circumvent any security or access controls of the App;</li>
          <li>Infringe upon intellectual property rights, including copyrights and trademarks.</li>
        </ul>
      </div>

      <div className="section">
        <h2>5. CONTENT AND INTELLECTUAL PROPERTY</h2>
        <p>
          You are solely responsible for ensuring that your use of any content downloaded through the App complies with applicable copyright laws and third-party terms of service.
          We do not claim ownership of content downloaded through the App, but we reserve the right to remove access to any content that infringes upon third-party rights.
        </p>
        <p>
          All intellectual property rights in the App, including but not limited to copyrights, trademarks, and patents, are and shall remain the sole property of TT Saver and its licensors.
        </p>
      </div>

      <div className="section">
        <h2>6. PRIVACY</h2>
        <p>
          Your use of the App is also governed by our Privacy Policy, which explains how we collect, use, and protect your information. The Privacy Policy is incorporated by reference into these Terms. Please review our Privacy Policy at: <Link to="/privacy">Privacy Policy</Link>
        </p>
      </div>

      <div className="section">
        <h2>7. DISCLAIMER OF WARRANTIES</h2>
        <p>
          THE APP IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, AND NON-INFRINGEMENT. WE DO NOT GUARANTEE THAT THE APP WILL BE UNINTERRUPTED, SECURE, OR ERROR-FREE.
        </p>
      </div>

      <div className="section">
        <h2>8. LIMITATION OF LIABILITY</h2>
        <p>
          TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL TT SAVER, ITS DIRECTORS, EMPLOYEES, OR AGENTS BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING WITHOUT LIMITATION, LOSS OF PROFITS, DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES, RESULTING FROM YOUR ACCESS TO OR USE OF OR INABILITY TO ACCESS OR USE THE APP.
        </p>
      </div>

      <div className="section">
        <h2>9. TERMINATION</h2>
        <p>
          We may terminate or suspend your access to the App immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach these Terms. Upon termination, your right to use the App will cease immediately.
        </p>
      </div>

      <div className="section">
        <h2>10. GOVERNING LAW AND DISPUTE RESOLUTION</h2>
        <p>
          These Terms shall be governed by and construed in accordance with the laws of the country in which TT Saver is incorporated or principally operates, without regard to its conflict of law provisions. Any dispute arising from or relating to these Terms or your use of the App shall be resolved exclusively in the courts located in that country.
        </p>
      </div>

      <div className="contact-info">
        <h2>CONTACT INFORMATION</h2>
        <p>If you have any questions about these Terms, please contact us at:</p>
        <p>Email: <a href="mailto:support@tsmallin.com">support@tsmallin.com</a></p>
        <p>Official Website: <Link to="/">ttsaver.tsmallin.com</Link></p>
      </div>



      <footer>
        <p>© {new Date().getFullYear()} TT Saver. All rights reserved.</p>
      </footer>
      </div>
    </div>
  );
};

export default Terms;
